import React from "react";

import "./style.scss";

export const PrivacyPolicyText = () => {
	return (
		<div className="big-text">
			<h1>Privacy Policy</h1>
			<h2>Personal Data Processing Policy (Privacy Policy)</h2>
			<p>
				These Rules define how SIA TenPinCams, registration number 42103088398 (hereinafter: ‘SIA’), processes data of
				natural persons (customers registered on the www.TenPinCam.com platform), the procedures for the exercising of
				rights of a user and other issues associated with the protection of personal data.
				<br />
				SIA as a controller performs processing of personal data in compliance with the General Data Protection
				Regulation № 2016/679 (GDPR) and with the Personal Data Protection Law, as well as with other enactments
				effective in Latvia.
				<br />
				SIA ensures privacy of personal data within the framework of applicable enactments and uses reasonable technical
				and administrative efforts for the protection of personal data.
				<br />
				SIA uses the AppMetrica service to collect statistical data and analytics of the application.
			</p>
			<h2>Personal data processing purposes, legal frameworks and principles</h2>
			<p>
				SIA organizes remote bowling games and tournaments, as well as remote coaching of players, by making video
				recording with the help of CCTV cameras.
				<br />SIA processes personal data for the following purposes:
				<br />• organization of remote bowling games andtournaments;
				<br />• testing and analysis of results;
				<br />• presentation of prizes;
				<br />• communication with players;
				<br />• for other purposes associated with the organization and hosting of games and tournaments.
				<br />
				The legal framework for the processing of personal data by SIA is the consent of the data subject (User) and
				observance of legitimate interests of the controller.
				<br />
				SIA protects personal data by applying conventional cutting-edge technological opportunities and reasonable
				available organizational, financial and technical resources, furthermore, updates and checks the security system
				on a regular basis.
			</p>
			<h2>Receiving personal data</h2>
			<p>
				SIA receives personal data from the data subject, www.TenPinCam.com website and related video surveillance
				system. The Company performs video surveillance with or without audio-recording facilities at bowling sites,
				with which the owners or legal holders have concluded an agreement for the installation of video cameras for
				recording bowling games. Video surveillance is performed for the purpose of watching the remote bowling games.
				Information concerning video surveillance and audio-recording is placed in bowling centres as warning signs
				before the video surveillance area.
			</p>
			<h2>Personal data retention period</h2>
			<p>
				SIA stores personal data in pursuance of certain purposes of personal data processing, where necessary for the
				implementation of own legitimate interests or consent of the data subject under conditions of appropriate
				processing of personal data.
			</p>
			<h2>Recipient of personal data</h2>
			<p>
				SIA does not transfer personal data to third parties. The data might be transferred only subject to the
				procedures set out by the law or at the request of the national bodies concerned, by registration of the
				persons, who have received such information.
			</p>
			<h2>Access to your personal data and other rights of the data subject</h2>
			<p>
				A data subject has the right to request, in reliance upon GDPR provisions, information concerning personal data
				under processing as regards the data subject, ask for the correction of wrong or incomplete information, request
				for the restrictions on personal data processing, protest against processing of personal data, demand to delete
				personal data subject to certain circumstances, where the legal framework is available.
				<br />A data subject has the right to receive or transfer his /her personal data to another data controller.
				Such right includes only those personal data, which the data subject has transferred to SIA for the purposes of
				the arrangement or agreement, where the processing is computer – equipped.
				<br />
				SIA contacts a data subject, by using contact information provided by the data subject.
			</p>
			<h2>Account Deletion</h2>
			<p>
				The user can delete his/her account at any time. To delete an account the user should go to Profile settings in
				the “Menu” section of the app. Then click “DELETE THE ACCOUNT”.
				<br />
				Upon the deletion of the account all of the personal data of the user, content of the mailbox, information about
				prize funds and active subscriptions will be deleted from the system.
			</p>
		</div>
	);
};
